import cn from 'classnames';
import React, { useEffect, useReducer, useRef } from 'react';

// STYLES
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { getNumberOfReels } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import styles from './Timer.scss';

interface IReelEvent {
    eventIds: Array<number>;
    eventName: string;
}

interface IComponentState {
    timeTotal: number;
    timeStart: number;
    timeTotalHistory: Array<number>;
    reels: { [key: string]: { start: number; end: number } };
}

const TimerReelsSpins: React.FC = () => {
    const [state, setState] = useReducer((state: IComponentState, newState: Partial<IComponentState>) => ({ ...state, ...newState }), {
        timeStart: 0,
        timeTotal: 0,
        timeTotalHistory: [],
        reels: {}
    });
    const gameStoreNumberOfReels = useAppSelector(getNumberOfReels);
    const stateRef = useRef(state);
    stateRef.current = state;

    useEffect(() => {
        EventsCenter.on(EGameEvents.REEL_SPIN_START_$, (reelData: IReelEvent) => {
            let reelIndex = reelData.eventIds[0];
            let currentReels = stateRef.current.reels;
            let startTime = Date.now();
            currentReels[reelIndex] = { start: startTime, end: 0 };
            if (reelIndex === 1) setState({ timeStart: startTime });
            setState({ reels: currentReels });
        });

        EventsCenter.on(EGameEvents.REEL_SPIN_END_$, (reelData: IReelEvent) => {
            let reelIndex = reelData.eventIds[0];
            let currentReels = stateRef.current.reels;
            let endTime = Date.now();

            currentReels[reelIndex] = { ...currentReels[reelIndex], end: endTime - currentReels[reelIndex].start };

            if (reelIndex === gameStoreNumberOfReels) {
                const totalTime = endTime - stateRef.current.timeStart;
                stateRef.current.timeTotalHistory.push(totalTime);
                setState({ timeTotal: endTime - stateRef.current.timeStart });
            }

            setState({ reels: currentReels });
        });
    }, []);

    const timeFormat = (time: number, br: boolean = false) => {
        const sec = (time * 0.001).toFixed(3);
        const mms = Math.round(time);
        return (
            <>
                {sec} s {br ? <br /> : ' / '} {mms} ms
            </>
        );
    };

    const timeAvarage = () => {
        let timeSum = 0;
        state.timeTotalHistory.forEach((time) => {
            timeSum = timeSum + time;
        });
        const avg = timeSum / state.timeTotalHistory.length;
        return <>{timeFormat(avg)}</>;
    };

    return (
        <div className={styles.reels_spins_container}>
            <div className={styles.reels_spins_header}>Reel spin duration:</div>
            <div className={styles.reels_spins_time_summary}>
                {Object.keys(state.reels).length > 0 ? (
                    <>
                        <div className={cn(styles.reels_spins_item, styles.reels_spins_item_label)}>
                            <div>Reels times:</div>
                        </div>
                        {Object.keys(state.reels).map((obj, i) => {
                            return (
                                <div key={i} className={styles.reels_spins_item}>
                                    <div>{obj} </div>
                                    <div>{timeFormat(state.reels[obj].end, true)}</div>
                                </div>
                            );
                        })}
                        <div className={cn(styles.reels_spins_item, styles.reels_spins_item_total)}>
                            <div>Total:</div>
                            <div>{timeFormat(state.timeTotal, true)}</div>
                        </div>
                        <div className={styles.reels_spins_time_avg}>
                            Avarage spin time duration for {Object.keys(state.timeTotalHistory).length} spins: {timeAvarage()}
                        </div>
                    </>
                ) : (
                    <>No spin action</>
                )}
            </div>
        </div>
    );
};

export default TimerReelsSpins;
